import { ComissionPayloadType } from "../../../types";

export const COMISSION_INITIAL_VALUES: ComissionPayloadType = {
  paymentSettings: {
    payPeriodId: "",
    disbursementDate: "",
    notes: "",
  },
};
